import("angular").then(angular => {
    var app = angular.module("tapAssetManager");

    app.controller("blockCtrl", [
        "$scope",
        "assetEmbedCodeGenerator",
        "sharerTwitter",
        "$uibModal",
        function($scope, assetEmbedCodeGenerator, sharerTwitter, $uibModal) {
            "use strict";

            $scope.getEmbedCode = function(asset, linkOnly) {
                return assetEmbedCodeGenerator.generate(
                    asset,
                    $scope.data.selectedSource,
                    $scope.referralCode,
                    $scope.data.metaData,
                    { linkOnly: linkOnly },
                );
            };
        },
    ]);

    app.directive("videoIframe", [
        "$sce",
        function($sce) {
            return {
                replace: true,
                scope: {
                    videoId: "=",
                    videoType: "=",
                },
                link: function(scope, el, attr) {
                    var baseUrl =
                        scope.videoType === "youtube_video"
                            ? "https://www.youtube.com/embed/"
                            : "https://player.vimeo.com/video/";
                    var extra =
                        scope.videoType === "youtube_video"
                            ? "?wmode=opaque&amp;rel=0&amp;autohide=1&amp;showinfo=0&amp;wmode=transparent"
                            : "";

                    el.html(
                        '<iframe class="full-w" frameborder="0" src="' +
                            baseUrl +
                            scope.videoId +
                            extra +
                            '" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>',
                    );
                },
            };
        },
    ]);
});
